import productImage from "../../assets/images/pro-1.png";

const CheckoutProductItem = () => {

    return(
        <div className="flex text-base text-black">
            <div className="image w-4/12">
                <img src={productImage} alt="" />
            </div>
            <div className="details flex-auto font-semibold">
                <div className="price">
                    <span>₺5.99</span>
                </div>
                <div className="title text-sm text-[#828282] py-2 font-normal">
                    <span>Be Legandary Lipstick-Sheer Navy Cream</span>
                </div>
                <div className="qty font-normal">
                    <span>Qty: </span>
                    <span>1</span>
                </div>
            </div>
        </div>
    )
}

export default CheckoutProductItem;